import LinkToPlatform from './LinkToPlatform';
import { navigateToPlatform } from './helpers';

export default LinkToPlatform;
export { navigateToPlatform };
